/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { Text } from '@msdyn365-commerce/core';
import { ProductCatalog } from '@msdyn365-commerce/retail-proxy';
import { getCatalogId } from '@msdyn365-commerce/core-internal';

import { ICatalogInfoData } from './catalog-info.data';
import { ICatalogInfoProps } from './catalog-info.props.autogenerated';

export interface ICatalogInfoViewProps extends ICatalogInfoProps<ICatalogInfoData> {
    className: string;
    catalogName: React.ReactNode;
    catalogDescription: React.ReactNode;
}

/**
 *
 * CatalogInfo component
 * @extends {React.PureComponent<ICatalogInfoProps<ICatalogInfoData>>}
 */
class CatalogInfo extends React.PureComponent<ICatalogInfoProps<ICatalogInfoData>> {
    public render(): JSX.Element | null {
        const catalogId = getCatalogId(this.props.context.request);
        const catalog = this._getCatalog(catalogId);
        const className = this.props.typeName;

        return this.props.renderView<ICatalogInfoViewProps>({
            ...this.props,
            className,
            catalogName: <Text className={`${className}__catalog-name`} tag='h2' text={catalog?.Name ?? ''} />,
            catalogDescription: <Text className={`${className}__catalog-description`} tag='h3' text={catalog?.Description ?? ''} />
        });
    }

    private _getCatalog = (catalogId: number): ProductCatalog | undefined =>
        this.props.data.catalogs?.result?.find(item => item.RecordId === catalogId);
}

export default CatalogInfo;
